import API from "@/config/api.js";
import PartnerService from "../services/partner.service"
import FixedCostService from "./fixedcost.service"


class ContractCostService {
  getListSupplierService(page, size, type) {
    return PartnerService.getPartnerByType(page, size, type)
  }

  saveContractCost(request) {
    return FixedCostService.saveFixedCost(request)
  }

  getContractCostInfo(fixedCostID) {
		return FixedCostService.getFxiedCostInfo(fixedCostID)
	}

  updateContractCost(request) {
		return FixedCostService.updateFixedCost(request)
	}

  searchContractCost(conditions) {
    return API.get(`cost/search/contract_cost/?start_date=${conditions.start_date}&end_date=${conditions.end_date}&contract_code=${conditions.contract_code}&invoice_code=${conditions.invoice_code}&category_cost=${conditions.category_cost}&partner_id=${conditions.partner_id}&supplier_inv_code=${conditions.supplier_invoice_code}&status=${conditions.status}&page=${conditions.page}`)
    .then(
      (response) => {
        return response.data;
      },
      (error) => {
        return Promise.reject(error);
      }
    )
  }

  deleteContractCost(contractCostID) {
    return FixedCostService.deleteFixedCost(contractCostID)
  }

  saveContractCostOfInvoice(request) {
    return API.post('cost/contract_cost_detail/add', request)
		.then(
			(response) => {
        return response.data;
			},
			(error) => {
        return Promise.reject(error);
			}
		)
  }

  saveContractCostModal(request) {
		return API.put(`cost/contract_cost_modal/edit/${request.id}`, request)
		.then(
			(response) => {
			return response.data;
			},
			(error) => {
			return Promise.reject(error);
			}
		)
	}

  getContractCostDetail (data) {
    return API.get(`cost/contract_cost_detail/?contract_id=${data.contract_id}&invoice_id=${data.invoice_id}&category_cost=${data.category_cost}`)
    .then(
      (response) => {
        return response.data;
      },
      (error) => {
        return Promise.reject(error);
      }
    )
  }

  getContractCostDetailByID (costID) {
    return API.get(`cost/contract_cost_detail/view/${costID}`)
    .then(
      (response) => {
        return response.data;
      },
      (error) => {
        return Promise.reject(error);
      }
    )
  }

  getContractCostDetailAddModalByID (costID) {
    return this.getContractCostDetailByID(costID);
  }
}

export default new ContractCostService();